import React, { Component } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Row, Table } from 'reactstrap';
import TablePaginator from '../../containers/TablePaginator/TablePaginator';
import ListActions from '../../containers/ListActions/ListActions';
import { connect } from 'react-redux';
import { fetchObjs, deleteObj } from '../../actions';

const emptyMessage = (<p>Não Existem registros para serem exibidos.</p>);

class UsuarioList extends Component {

    state = {
        url: '/usuarios'
    }

    componentDidMount() {
        this.props.fetchObjs(this.state.url);
    }

    render() {
        return (
            <div className="animated fadeIn">
                <Row>
                    <Col>
                        <Card>
                            <CardHeader>
                                <Row>
                                    <Col xs="6" sm="6">
                                        <strong>Usuários</strong>
                                    </Col>
                                    <Col  xs="6" sm="6" style={{ textAlign: 'right' }}>
                                        <Button type="button" size="sm" color="primary" onClick={() => this.props.history.push(`${this.state.url}/new`)}>
                                            <i className="fa fa-plus"></i> Novo
                                        </Button>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                {this.props.usuarios.length === 0 ? emptyMessage : ([
                                    <Table hover bordered striped responsive size="sm">
                                        <thead>
                                            <tr key="head">
                                                <th key="id">Código</th>
                                                <th key="login">Login</th>
                                                <th key="nome">Nome</th>
                                                <th key="acoes" xs="12" sm="1" className="text-center">Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.usuarios.map((usuario, i) => {
                                                return (
                                                    <tr key={`tr${i}`}>
                                                        <td key={`id${i}`} onClick={() => this.props.history.push(`${this.state.url}/${usuario.ID}`)}>{usuario ? usuario.ID : ''}</td>
                                                        <td key={`login${i}`} onClick={() => this.props.history.push(`${this.state.url}/${usuario.ID}`)}>{usuario ? usuario.LOGIN : ''}</td>
                                                        <td key={`nome${i}`} onClick={() => this.props.history.push(`${this.state.url}/${usuario.ID}`)}>{usuario && usuario.pessoa ? usuario.pessoa.NOME : ''}</td>
                                                        <td key={`actions${i}`}><ListActions key={i} {...this.props} {...this.state} id={usuario.ID} /></td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>,
                                    <TablePaginator {...this.props} {...this.state} />
                                ])}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        usuarios: state.obj.records ? state.obj.records : [],
        meta: state.obj.meta ? state.obj.meta : {}
    }
}

export default connect(mapStateToProps, { fetchObjs, deleteObj })(UsuarioList);

